import React, { useEffect, useRef, useState } from 'react';
import { Grid, Stack, Snackbar, Alert, } from '@mui/material';
import { Input } from '../../components/input';
import { validateUserName, internalUserMailCheck } from 'services';
import MultiSelectWithAdmin from 'components/MultiSelect/MultiSelect';
import { getRolesApi } from '../../services/projects';

const DefaultData = {
    "firstName": "",
    "lastName": "",
    "phoneNumber": "",
    "mobile": "",
    "notes": "",
    "isInvoiceEmail": "",
}

const ALPHA_NUMERIC_DASH_REGEX = /^[ A-Za-z0-9_@./&+-]*$/;

export const RegisterForm = ({
    getEmpData,
    labUserCheck
}: any) => {
    const [empData, setEmpData] = useState<any>(DefaultData);
    const [errorMessage, setErrorMessage] = useState(false);
    const [errorCodeMessage, setErrorCodeMessage] = useState('');
    const [emptyError, setEmptyError] = useState(false);
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [data, setData] = useState([]);
    const [selectedValues, setSelectedValues] = useState([]);
    const [roles, setRoles] = useState([]);
    const rolesRequestStarted = useRef(false);

    useEffect(() => {
        if (rolesRequestStarted.current) return;

        rolesRequestStarted.current = true;
        getRolesApi().then((response: any) => {
            if (response?.status === 200) {
                setRoles(response.data || []);
            }
        });
    }, []);

    const updateEmpData = (ev: any, name: any) => {
        let val = ev.target.value;
        let data = empData;
        data[name] = val;
        setEmpData(data);
        getEmpData(data);
    }

    const handleEmailChange = (ev: any) => {
        setEmail(ev.target.value);
        if (ev.target.value.length === 0) {
            setData([]);
        }
    }

    const isValidEmail = (email) => /\S+@\S+\.\S+/.test(email);

    const validateEmail = async (val: any, name: any) => {
        if (val.length > 0) {
            if (!isValidEmail(email)) {
                setError("Invalid email format");
                return;
            }
            setError('');
            try {
                await validateUserName(val).then((res: any) => {
                    if (res.status === 200) {
                        let data = empData;
                        data['status'] = (res.data === true);
                        data[name] = val;
                        setEmpData(data);
                        getEmpData(data);
                        if (res.data === true) {
                            setError("An account with this email already exist")
                        } else {
                            if ((labUserCheck && (labUserCheck.UserType === 'Internal'))) {
                                internalEmailCheck(val, name);
                            }
                        }
                    } else {
                        setErrorMessage(true);
                        setErrorCodeMessage(res.data);
                    }
                })
            } catch (err) {
                setError("Error validating email. Please try again.");
            }
        } else {
            setError('');
        }
    }

    const internalEmailCheck = (val: any, name: any) => {
        internalUserMailCheck(val).then((res: any) => {
            if (res.status === 200) {
                if (res.data.length > 0) {
                    let data = empData;
                    data[name] = val;
                    setEmpData(data);
                    getEmpData(data);
                    setData(res.data);
                } else {
                    setEmptyError(true);
                    setData([]);
                }
            } else {
                setErrorMessage(true);
                setErrorCodeMessage(res.data);
            }
        })
    }

    useEffect(() => {
        let item = empData;
        if (data.length > 0) {
            item['clientUserMaps'] = selectedValues;
        }
         else {
            item['clientUserMaps'] = [];
        }
        getEmpData(item);
    }, [selectedValues])

    let columnSize = (labUserCheck && (labUserCheck.UserType !== 'Internal')) ? 12 : 6;

    return (
        <div style={{ padding: '0 30%' }}>
            <Grid container spacing={2}>
                <Grid item xs={columnSize} sm={columnSize} md={columnSize}>
                    <Input
                        required
                        fullWidth={true}
                        value={email}
                        onChange={(ev: any) => handleEmailChange(ev)}
                        onBlur={(ev: any) => validateEmail(ev.target.value, 'emailId')}
                        error={!!error}
                        helperText={error}
                        name="emailId"
                        label="Email Id"
                        size="small"
                    />
                </Grid>
                {(labUserCheck && (labUserCheck.UserType === 'Internal')) ?
                    <Grid item xs={6} sm={6} md={6}>
                        <MultiSelectWithAdmin
                           data={data}
                                    roles={roles}
                           setSelectedValues={setSelectedValues}
                        />
                    </Grid>
                    : null}
                <Grid item xs={6} sm={6} md={6}>
                    <Input
                        required
                        fullWidth={true}
                        onChange={(ev: any) => updateEmpData(ev, 'firstName')}
                        onKeyDown={(event) => {
                            if (!ALPHA_NUMERIC_DASH_REGEX.test(event.key)) {
                                event.preventDefault();
                            }
                        }}
                        name="firstName"
                        label="First Name"
                        size="small"
                    />
                </Grid>
                <Grid item xs={6} sm={6} md={6}>
                    <Input
                        required
                        fullWidth={true}
                        onChange={(ev: any) => updateEmpData(ev, 'lastName')}
                        onKeyDown={(event) => {
                            if (!ALPHA_NUMERIC_DASH_REGEX.test(event.key)) {
                                event.preventDefault();
                            }
                        }}
                        name="lastName"
                        label="Last Name"
                        size="small"
                    />
                </Grid>
                <Grid item xs={6} sm={6} md={6}>
                    <Input
                        onChange={(ev: any) => updateEmpData(ev, 'phoneNumber')}
                        name="phoneNumber"
                        label="Phone Number"
                        size="small"
                        fullWidth={true}
                    />
                </Grid>
                <Grid item xs={6} sm={6} md={6}>
                    <Input
                        onChange={(ev: any) => updateEmpData(ev, 'mobile')}
                        name="mobile"
                        label="Mobile"
                        size="small"
                        fullWidth={true}
                    />
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                    <Input
                        onChange={(ev: any) => updateEmpData(ev, 'notes')}
                        rows={3}
                        multiline={true}
                        name="notes"
                        label="Notes"
                        size="small"
                        fullWidth={true}
                    />
                </Grid>
            </Grid>
            <Stack sx={{ width: '100%', marginTop: 2 }} spacing={2}>
                <Snackbar open={emptyError} autoHideDuration={6000} onClose={() => setEmptyError(false)}>
                    <Alert severity="error" onClose={() => setEmptyError(false)}>Contact not found! Please sync contacts from ELVIS before trying to add a new user.</Alert>
                </Snackbar>
                <Snackbar open={errorMessage} autoHideDuration={6000} onClose={() => setErrorMessage(false)}>
                    <Alert severity="error" onClose={() => setErrorMessage(false)}>{errorCodeMessage}</Alert>
                </Snackbar>
            </Stack>
        </div >
    );
}